import { ChatRoom } from "./ChatRoom";
import { FileMessage } from "./FileMessage";
import { Message } from "./Message";

export class MultiUserRoom extends ChatRoom {
  participants: string[];

  constructor({
    chatRoomId,
    roomName,
    messages,
    type,
    isSessionActive = true,
    unreadMessageCount = 0,
    isCreator ,
    admin,
    participants,

  }: {
    chatRoomId: string;
    roomName: string;
    messages: (Message|FileMessage)[];
    type: string;
    isSessionActive?: boolean;
    unreadMessageCount?: number;
    isCreator: boolean| null;
    admin: string | null;
    participants: string[];

  }) {
    super(chatRoomId, roomName, messages, type, {
      isSessionActive,
      unreadMessageCount,
      isConference: false,
      isGroup: false,
    });
    this.participants = participants;
    this.isCreator = isCreator;
    this.admin = admin;
  }

  addParticipant(participant: string) {
    if (!this.participants.includes(participant)) {
      this.participants.push(participant);
    }
  }

  removeParticipant(participant: string) {
    this.participants = this.participants.filter((p) => p !== participant);
  }
}
